import { createClient } from '@supabase/supabase-js'

// Get environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables')
  console.error('Required: VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY')
  throw new Error('Supabase configuration is missing. Check your .env file.')
}

// Create a single supabase client for interacting with your database
export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Sanitize search input for use in PostgREST filter expressions (.or() / .ilike())
// Escapes characters that have special meaning in PostgREST filter syntax
export const sanitizeSearchInput = (input) => {
  if (!input || typeof input !== 'string') return ''
  // Remove characters that could break or manipulate PostgREST filter expressions
  return input.replace(/[\\%_().,]/g, '')
}

// Helper function to handle Supabase errors
// Returns a structured error object with user-friendly message and metadata
export const handleSupabaseError = (error) => {
  if (!error) return null

  const code = error.code || error.status
  const rawMessage = error.message || ''

  // Postgres/PostgREST error codes
  const errorMap = {
    'PGRST116': 'Record not found',
    'PGRST301': 'Request timeout — please try again',
    '23505': 'This record already exists',
    '23503': 'Cannot delete — this record is referenced elsewhere',
    '23514': 'Invalid data — check your input',
    '42501': 'Permission denied',
    '42P01': 'Service configuration error',
    'FunctionNotFound': 'Service temporarily unavailable',
  }

  // HTTP status codes (from edge functions / fetch)
  const httpMap = {
    401: 'Session expired — please sign in again',
    403: 'You don\'t have permission for this action',
    404: 'Not found',
    429: 'Too many requests — please wait and try again',
    500: 'Server error — please try again',
    503: 'Service temporarily unavailable',
  }

  const message = errorMap[code] || httpMap[code] || httpMap[error.status] || rawMessage || 'An unexpected error occurred'

  return {
    message,
    code,
    original: error,
    isRetryable: ['PGRST301'].includes(code) || [429, 500, 503].includes(error.status),
    isAuthError: ['42501'].includes(code) || [401, 403].includes(error.status),
  }
}